module.exports = __webpack_public_path__ + "static/media/GreenDotted.0f0351d7.svg";